import { Link, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DateFilter from "../../Components/CommonComponent/Dropdown/DateFilter";
import { useContext } from "react";
import { CommonContext } from "../../App";

function TabsButtonAccountBook() {
  const location = useLocation();
  const { t } = useTranslation();

  const tabs = [
    { title: t("view"), path: "groups-table" },
    { title: t("create"), path: "types-groups" },

  ];
    const { setDateRange } = useContext(CommonContext);

  return (
    <div>
     <header className="tabs-header py-1 pt-2 bg-theme-webBackground  sticky top-0 z-[990]  flex gap-3 justify-between px-2   ">
     
        <div className="flex gap-3">
            {tabs.map((tab) => {

          let isActive = false;

          if (tab.path === "groups-table") {
            isActive =
              location.pathname === "/account-books" ||
              location.pathname.startsWith("/account-books/groups-table");
          }

          if (tab.path === "types-groups") {
            isActive =
              location.pathname.startsWith("/account-books/types-groups");
          }
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`tab no-underline rounded-1 h-7 mt-[2px] pt-[3px] text-sm  px-2  ${isActive
                  ? `bg-theme-headerBg text-theme-color font-medium border-1 border-theme-headerBg`
                  : `text-theme-tabColor border-1  border-black hover:!border-theme-headerBg  hover:!text-theme-headerBg `
                  }`}
            >
              {tab.title}
            </Link>
          );
        })}
        </div>
         <div className="text-theme-headerBg" >
          <DateFilter
            customMode="range"
            availableFilters={[
              "default",
              "today",
              "yesterday",
              "lastWeek",
              "last15",
              "lastMonth",
              "thisMonth",
              "custom",
            ]}
            onChange={(r) =>
              setDateRange({
                startDate: r.startDate,
                endDate: r.endDate,
              })
            }
          />
        </div>
      </header>

      <main className="tab-content">
        <Outlet />
      </main>
    </div>
  );
}

export default TabsButtonAccountBook;
